import React from 'react';

interface MyYusoServicesIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

const MyYusoServicesIcon: React.FC<MyYusoServicesIconProps> = ({
  width = 35,
  height = 24,
  color = '#91B1BE',
  className = '',
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 35 24'
    fill='none'
    className={className}
  >
    <g className='dark:child:stroke-primary-500' clipPath='url(#clip0_7_86)'>
      <path
        d='M17.344 1C15.1812 1.01622 13.0428 1.45833 11.0509 2.30107C9.05895 3.14381 7.25255 4.37068 5.73483 5.91162C4.21711 7.45255 3.0178 9.27737 2.20539 11.2818C1.39298 13.2863 0.983388 15.4312 0.999997 17.594V20.611C0.999997 21.1889 1.22957 21.7431 1.63821 22.1518C2.04685 22.5604 2.60109 22.79 3.179 22.79H31.508C31.7941 22.7901 32.0775 22.7339 32.3419 22.6245C32.6064 22.5151 32.8466 22.3547 33.0491 22.1525C33.2515 21.9502 33.4121 21.7101 33.5217 21.4458C33.6314 21.1815 33.6879 20.8981 33.688 20.612V17.59C33.7205 13.2226 32.0167 9.02108 28.9514 5.90985C25.8861 2.79863 21.7114 1.0325 17.344 1Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.985 22.791V21.701C12.985 20.5452 13.4441 19.4367 14.2614 18.6194C15.0787 17.8021 16.1872 17.343 17.343 17.343C18.4988 17.343 19.6073 17.8021 20.4246 18.6194C21.2418 19.4367 21.701 20.5452 21.701 21.701V22.791'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.613 7.54102L17.344 17.347'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.993 17.344C6.84846 17.344 6.70983 17.2866 6.60763 17.1844C6.50542 17.0822 6.448 16.9435 6.448 16.799C6.448 16.6545 6.50542 16.5158 6.60763 16.4136C6.70983 16.3114 6.84846 16.254 6.993 16.254'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M6.99298 17.344C7.13752 17.344 7.27615 17.2866 7.37835 17.1844C7.48056 17.0822 7.53798 16.9435 7.53798 16.799C7.53798 16.6545 7.48056 16.5158 7.37835 16.4136C7.27615 16.3114 7.13752 16.254 6.99298 16.254'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M9.17201 11.899C9.02747 11.899 8.88885 11.8416 8.78664 11.7394C8.68443 11.6372 8.62701 11.4985 8.62701 11.354C8.62701 11.2094 8.68443 11.0708 8.78664 10.9686C8.88885 10.8664 9.02747 10.809 9.17201 10.809'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M9.172 11.899C9.31654 11.899 9.45516 11.8416 9.55737 11.7394C9.65958 11.6372 9.717 11.4985 9.717 11.354C9.717 11.2094 9.65958 11.0708 9.55737 10.9686C9.45516 10.8664 9.31654 10.809 9.172 10.809'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M13.53 7.54099C13.3854 7.54099 13.2468 7.48357 13.1446 7.38136C13.0424 7.27915 12.985 7.14053 12.985 6.99599C12.985 6.85145 13.0424 6.71282 13.1446 6.61061C13.2468 6.50841 13.3854 6.45099 13.53 6.45099'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M13.53 7.54099C13.6745 7.54099 13.8131 7.48357 13.9153 7.38136C14.0175 7.27915 14.075 7.14053 14.075 6.99599C14.075 6.85145 14.0175 6.71282 13.9153 6.61061C13.8131 6.50841 13.6745 6.45099 13.53 6.45099'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M25.514 11.895C25.3695 11.895 25.2308 11.8376 25.1286 11.7354C25.0264 11.6332 24.969 11.4945 24.969 11.35C24.969 11.2054 25.0264 11.0668 25.1286 10.9646C25.2308 10.8624 25.3695 10.805 25.514 10.805'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M25.515 11.895C25.6596 11.895 25.7982 11.8376 25.9004 11.7354C26.0026 11.6332 26.06 11.4945 26.06 11.35C26.06 11.2054 26.0026 11.0668 25.9004 10.9646C25.7982 10.8624 25.6596 10.805 25.515 10.805'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M27.693 17.348C27.5485 17.348 27.4098 17.2906 27.3076 17.1884C27.2054 17.0862 27.148 16.9475 27.148 16.803C27.148 16.6585 27.2054 16.5198 27.3076 16.4176C27.4098 16.3154 27.5485 16.258 27.693 16.258'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M27.694 17.348C27.8386 17.348 27.9772 17.2906 28.0794 17.1884C28.1816 17.0862 28.239 16.9475 28.239 16.803C28.239 16.6585 28.1816 16.5198 28.0794 16.4176C27.9772 16.3154 27.8386 16.258 27.694 16.258'
        stroke={color}
        strokeWidth='2'
      />
    </g>
    <defs>
      <clipPath id='clip0_7_86'>
        <rect width='34.687' height='23.791' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default MyYusoServicesIcon;
